function responsiveWidth(value: number) {
  const percentage = 1
  const windowWidth = window.innerWidth
  const figmaWindowWidth = 1440

  const newSize = (
    ((value * windowWidth) / figmaWindowWidth) *
    percentage
  ).toFixed(2)

  return `${newSize}px`
}

function responsiveHeight(value: number) {
  const percentage = 1
  const windowHeight = window.innerHeight
  const figmaWindowHeight = 850

  const newSize = (
    ((value * windowHeight) / figmaWindowHeight) *
    percentage
  ).toFixed(2)

  return `${newSize}px`
}

export default { responsiveHeight, responsiveWidth }
